class TrustpilotMedalElement extends HTMLElement {
  connectedCallback() {
    this.#loadData();
  }

  async #loadData() {
    const templateId = this.dataset.templateId;
    const businessUnitId = this.dataset.businessUnitId;
    const locale = this.dataset.locale || 'en-GB';

    if (!templateId || !businessUnitId) return;

    const url = new URL(`https://widget.trustpilot.com/trustbox-data/${templateId}`);
    url.searchParams.set('businessUnitId', businessUnitId);
    url.searchParams.set('locale', locale);

    try {
      const response = await fetch(url.toString());

      if (!response.ok) return;

      const data = await response.json();
      const businessUnit = data.businessUnit || data.businessEntity;

      if (!businessUnit) return;

      const ratingEl = this.querySelector('.trustpilot-medal-rating');
      const scoreEl = this.querySelector('.trustpilot-medal-score');
      const countEl = this.querySelector('.trustpilot-medal-reviews-count');

      if (data.starsString && ratingEl) {
        ratingEl.textContent = data.starsString;
      }

      if (businessUnit.trustScore != null && scoreEl) {
        const formattedScore = Number(businessUnit.trustScore)
          .toFixed(1)
          .replace(/\.0$/, '');
        scoreEl.textContent = `${formattedScore}/5`;
      }

      if (businessUnit.numberOfReviews?.total != null && countEl) {
        countEl.textContent = businessUnit.numberOfReviews.total;
      }
    } catch {
      // Keep fallback values from theme settings.
    }
  }
}

if (!customElements.get('trustpilot-medal')) {
  customElements.define('trustpilot-medal', TrustpilotMedalElement);
}
